"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    id: 'woodwork',
    name: 'Woodwork',
    background_color: '#4f3c2d',
    background_image: 'https://assets.raydiant.com/images/woodwork.jpg',
    background_image_portrait: 'https://assets.raydiant.com/images/woodwork-portrait.jpg',
    heading_font: 'https://fonts.raydiant.com/Pacifico-Regular.woff',
    heading_text_color: '#f6f6f6',
    heading_2_font: 'https://fonts.raydiant.com/PlayfairDisplay-Bold.woff',
    heading_2_text_color: '#f6f6f6',
    body_font: 'https://fonts.raydiant.com/PlayfairDisplay-Regular.woff',
    body_text_color: '#ffffff',
    border_color: '#f9f613',
};
//# sourceMappingURL=woodwork.js.map


// WEBPACK FOOTER //
// ../raydiant-kit/lib/themes/woodwork.js